import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ModalComponent } from '../../../components/modal/modal.component';
import { CreateSectorComponent } from '../create-sector/create-sector.component';
import { SectorService } from '../sector.service';
import { Sector } from '../../../models/sector.model';

@Component({
  selector: 'app-list-sector',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    ModalComponent,
    CreateSectorComponent,
    PaginatorModule
  ],
  templateUrl: './list-sector.component.html'
})
export class ListSectorComponent implements OnInit {
  sectorId!: number | null;
  searchTerm = '';
  totalRecords = 0;
  sectors: Sector[] = [];
  loading = false;
  formVisible = false;
  first = 0;
  rows = 5;
  currentPage = 1;

  constructor(private location: Location, private sectorService: SectorService) {}

  ngOnInit(): void {
    this.getData();
  }

  closeModal(): void {
    this.sectorId = null;
  }

  getData(): void {
    this.sectorService.getAll(this.searchTerm, true, this.currentPage).subscribe({
      next: data => {
        this.sectors = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: { first?: number }): void {
    this.first = event.first ?? 0;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  createSector(): void {
    this.changeModal();
  }

  onFormSubmit(): void {
    this.changeModal();
    this.getData();
  }

  changeModal(): void {
    this.formVisible = !this.formVisible;
  }

  edit(sector: Sector): void {
    this.sectorId = sector.id;
    this.changeModal();
  }

  goBack(): void {
    this.location.back();
  }
}
